import { SvgBase } from "../svg.base";

export const ArrowLeft: React.FC<{ width?: string; height?: string }> = ({
  width,
  height,
}) => (
  <SvgBase width={width || "48"} height={height || "48"} viewBox="0 0 48 48">
    <path
      d="M18.8166 20L24.7166 14.1C25.027 13.7877 25.2013 13.3653 25.2013 12.925C25.2013 12.4847 25.027 12.0623 24.7166 11.75C24.5617 11.5938 24.3773 11.4698 24.1742 11.3852C23.9711 11.3006 23.7533 11.257 23.5333 11.257C23.3133 11.257 23.0954 11.3006 22.8923 11.3852C22.6892 11.4698 22.5049 11.5938 22.3499 11.75L15.2833 18.8167C15.1271 18.9716 15.0031 19.156 14.9185 19.3591C14.8338 19.5622 14.7903 19.78 14.7903 20C14.7903 20.22 14.8338 20.4379 14.9185 20.641C15.0031 20.8441 15.1271 21.0284 15.2833 21.1833L22.3499 28.3333C22.5057 28.4878 22.6904 28.61 22.8934 28.693C23.0965 28.7759 23.3139 28.818 23.5333 28.8167C23.7526 28.818 23.9701 28.7759 24.1731 28.693C24.3762 28.61 24.5609 28.4878 24.7166 28.3333C25.027 28.0211 25.2013 27.5987 25.2013 27.1583C25.2013 26.718 25.027 26.2956 24.7166 25.9833L18.8166 20Z"
      fill="#D2D2D2"
    />
  </SvgBase>
);
